export const formattedDate = (date) => {
  if (!date) {
    return '';
  }

  const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
  const month = (date.getUTCMonth() + 1) > 9 ? date.getUTCMonth() : `0${date.getUTCMonth() + 1}`;
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

export const convertUTCDateToLocalDate = (utcDateStr) => {
  const utcDate = new Date(utcDateStr);
  const newDate = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60 * 1000));

  return newDate;
};

export const convertDateToUTCString = (date) => {
  return date.toISOString().replace('T', ' ').replace(/\.\d{3}Z/, '');
};
